import { ExpandLess, ExpandMore, Feed, LinkOutlined } from '@mui/icons-material'
import { Card, CardContent, List, ListItem, Stack, Typography, Link, ListItemButton, AspectRatio, IconButton } from '@mui/joy'
import { Collapse } from '@mui/material'
import { TypeExplanation } from 'app/constants/types/exam.types'
import { getYouTubeEmbedUrl, validateYouTubeUrl } from 'app/utils'
import React from 'react'
import useStyleCardExplanation from './utils/useStyleCardExplanation'

type Props = {
  title?: string,
  explanation?: TypeExplanation,
}


const CardVideo = ({ titlePapers, item, index }: { titlePapers?: string, item: any, index: number }) => {

  const [open, setOpen] = React.useState(index == 0);
  const url = getYouTubeEmbedUrl(item.url)

  return (
    <ListItem sx={{ display: 'grid', backgroundColor: open ? '#dce6ff' : 'unset', borderRadius: 8, border: open ? '1px solid #d6e2ff' : 'unset', pb: open ? 2 : 0, mb: open ? 2 : 0 }}>
      <ListItemButton sx={{ borderRadius: 8, justifyContent: 'space-between', m: 'unset', width: 1, '&:hover': open ? { backgroundColor: '#b9ccfd !important' } : {} }} onClick={() => setOpen(!open)}>
        <Typography fontWeight={open ? 600 : 500}>{titlePapers}</Typography>
        <IconButton>
          {
            open ?
              <ExpandLess />
              :
              <ExpandMore />
          }
        </IconButton>
      </ListItemButton>
      <Stack className={open ? 'slide-in-bottom' : 'slide-out-bottom'} sx={{ width: '100%', overflow: 'auto', maxWidth: 700 }}>
        <AspectRatio ratio='2/1' sx={{ borderRadius: 8 }}>
          {
            validateYouTubeUrl(item?.url) ?
              <iframe
                src={url}
                height={700}
                width={1200}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                style={{}}
              >
              </iframe>
              :
              <video src={item?.url}
                height={700}
                width={1200}
                controls
              >
              </video>
          }
        </AspectRatio>
      </Stack>
    </ListItem>
  );

}

const CardExplanation = ({ title, explanation }: Props) => {

  const isPaperExist = explanation?.papers && explanation?.papers?.length > 0
  const isVideoExist = explanation?.videos && explanation?.videos?.length > 0
  const style = useStyleCardExplanation({ isPaperExist, isVideoExist })

  return (
    <Stack sx={style.main}>
      {
        isPaperExist &&
        <Card sx={{ overflow: 'auto' }}>
          <Stack>
            <Typography level='h3' ml={'10px'}>Returned Paper</Typography>
          </Stack>
          <CardContent sx={{ overflow: 'auto' }}>
            <List sx={style.listPapers}>
              {
                explanation?.papers?.map((item, index) => {
                  const titlePapers = ((title || '') + ' Returned Paper') + (explanation?.videos && explanation?.videos?.length > 1 ? (' (' + (index + 1)) + ')' : '')
                  return (
                    <Link href={item.url} target='_blank' key={'card-explanation-' + titlePapers} style={{ height: 'fit-content', width: 'fit-content' }}>
                      <ListItemButton sx={style.paper}>
                        <Feed sx={style.paperIcon} />
                        <Typography>{titlePapers}</Typography>
                      </ListItemButton>
                    </Link>
                  )
                })
              }
            </List>
          </CardContent>
        </Card>
      }
      {
        isVideoExist &&
        <Card sx={{ overflow: 'auto' }}>
          <Stack>
            <Typography level='h3' ml={'10px'}>Explanation Video</Typography>
          </Stack>
          <CardContent sx={{ overflow: 'auto' }}>
            <List>
              {
                explanation?.videos?.map((item, index) => {
                  const titlePapers = ((title || '') + ' Explanation Video') + (explanation?.videos && explanation?.videos?.length > 1 ? (' (' + (index + 1)) + ')' : '')
                  return (
                    <CardVideo
                      key={'card-explanation-video-' + titlePapers}
                      titlePapers={titlePapers}
                      item={item}
                      index={index}
                    />
                  )
                })
              }
            </List>
          </CardContent>
        </Card>
      }
    </Stack>
  )
}

export default CardExplanation